import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 26,
	viewBox: "0 0 28 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 19.6668H14.0134M14 10.3334V15.6668M6.54946 25.0001H21.4506C23.8262 25.0001 25.0139 25.0001 25.7106 24.5005C26.3185 24.0646 26.7154 23.3934 26.8044 22.6507C26.9064 21.7995 26.3339 20.7587 25.1891 18.6772L17.7386 5.13074C16.5196 2.91453 15.9102 1.80643 15.1049 1.43983C14.403 1.12032 13.5971 1.12032 12.8952 1.43983C12.0899 1.80643 11.4804 2.91453 10.2615 5.13073L2.81094 18.6772C1.66612 20.7587 1.09371 21.7995 1.19569 22.6507C1.28469 23.3934 1.68155 24.0646 2.28946 24.5005C2.98614 25.0001 4.17391 25.0001 6.54946 25.0001Z",
		stroke: "#FFB300",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWarning;
